import type { RootState } from '@oneview/redux/rootReducer';
import { createSelector } from '@reduxjs/toolkit';

export const selectMisc = (state: RootState) => state.misc;

export const selectCrmState = createSelector(selectMisc, (misc) => misc.crmOpened);

export const selectSidebarState = createSelector(selectMisc, (misc) => misc.sidebarOpened);

export const selectQuoteSummarySymbol = createSelector(selectMisc, (misc) => misc.quoteSummarySymbol);

export const selectBaseCurrency = createSelector(selectMisc, (misc) => misc.selectedBaseCurrency);
